import { css, SerializedStyles } from '@emotion/core';
import { Theme, helpText, normalText, secondaryText } from 'features/Theme';

const styles = {
  headingContainer: (theme: Theme): SerializedStyles => css`
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  finePrint: (theme: Theme): SerializedStyles => css`
    ${helpText(theme)};
    margin-top: ${theme.mui.spacing(3)}px;
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  body: (theme: Theme): SerializedStyles => css`
    ${normalText(theme)}
    margin-bottom: ${theme.mui.spacing(3)}px;
  `,
  restartText: (theme: Theme) => css`
    ${secondaryText(theme)}
  `,
};

export default styles;
